var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as A from "fp-ts/Array";
import { pipe } from "fp-ts/lib/function";
import concat from "lodash/concat";
import isEmpty from "lodash/isEmpty";
import React, { useEffect, useState } from "react";
import { DataGridView } from "../components/DataGridView";
import { LogicOperator, } from "../type";
import { convertFilterItem, useDebouncedSearch } from "../utils";
export const DataGridContainer = (_a) => {
    var { title, rows, columns, filterSearchPaginateProps } = _a, props = __rest(_a, ["title", "rows", "columns", "filterSearchPaginateProps"]);
    const { setSearchText, setFilterObject, onSortModelChange } = filterSearchPaginateProps;
    const debounceSearch = useDebouncedSearch();
    const handleDebounceOnSearch = (str) => {
        debounceSearch(setSearchText, str);
    };
    const [colFilterItems, setColFilterItems] = useState([]);
    const [colLogicOperator, setColLogicOperator] = useState(LogicOperator.and);
    const handleFilterItemChange = (item, type) => {
        setColFilterItems((prev) => {
            const isExist = pipe(prev, A.some((fi) => fi.id === item.id));
            if (isExist && type === "delete") {
                return pipe(prev, A.filter((p) => p.id !== item.id));
            }
            if (isExist) {
                return pipe(prev, A.map((p) => (p.id === item.id ? item : p)));
            }
            return concat(prev, item);
        });
    };
    const handleLogicOperatorChange = (logic) => {
        if (colFilterItems.length)
            setColLogicOperator(logic);
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        setFilterObject(!isEmpty(colFilterItems)
            ? {
                filters: colFilterItems.map(convertFilterItem),
                logicOperator: colLogicOperator,
            }
            : undefined);
    }, [colFilterItems, colLogicOperator]);
    return (React.createElement(DataGridView, Object.assign({ title: title, columns: columns, filterSearchPaginateProps: filterSearchPaginateProps, handleDebounceOnSearch: handleDebounceOnSearch, handleFilterItemChange: handleFilterItemChange, handleLogicOperatorChange: handleLogicOperatorChange, colLogicOperator: colLogicOperator, colFilterItems: colFilterItems, rows: rows, onSortModelChange: onSortModelChange }, props)));
};
//# sourceMappingURL=DataGridContainer.js.map